export const message = {
  language: '中文',
  // admin
  user: {},
  login: {},
  register: {},
  forgetPassword: {},
  updatePassword: {},
  // admin
  admin: {},
  index: {},
  marketing: { // 营销管理

  },
  report: { // 报表管理

  },
  settlement: { //计算记录

  },
  store: { //结算记录
  }
}



// WEBPACK FOOTER //
// ./src/i18n/cn/index.js